import 'react-grid-layout/css/styles.css';
import 'react-resizable/css/styles.css';
import Dashboard from '@/app/dashboard/components/dashboard';

export default function DashboardPage() {
  return <Dashboard />;
}
